import Vue from 'vue'
import Vuex from 'vuex'

import config from './modules/config'
import inputData from './modules/inputData'
import lang from './modules/lang'
import dropShops from './modules/dropShops'

Vue.use(Vuex)

const state = {}

const mutations = {}

const actions = {}

const getters = {}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    config,
    inputData,
    lang,
    dropShops
  }
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js